function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 36,
  cy: 36,
  r: 36,
  fill: "#6AD087"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#circle-check4_svg__clip0_1866_4343)"
}, React.createElement("path", {
  d: "M31 42.95L24.05 36l-2.366 2.35L31 47.667l20-20-2.35-2.35L31 42.95z",
  fill: "#fff"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "circle-check4_svg__clip0_1866_4343"
}, React.createElement("path", {
  fill: "#fff",
  transform: "translate(16 16)",
  d: "M0 0h40v40H0z"
})));

var SvgCircleCheck4 = function SvgCircleCheck4(props) {
  return React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml,%3Csvg width='72' height='72' viewBox='0 0 72 72' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Ccircle cx='36' cy='36' r='36' fill='%236AD087'/%3E %3Cg clip-path='url(%23clip0_1866_4343)'%3E %3Cpath d='M31.0003 42.9502L24.0503 36.0002L21.6836 38.3502L31.0003 47.6669L51.0003 27.6669L48.6503 25.3169L31.0003 42.9502Z' fill='white'/%3E %3C/g%3E %3Cdefs%3E %3CclipPath id='clip0_1866_4343'%3E %3Crect width='40' height='40' fill='white' transform='translate(16 16)'/%3E %3C/clipPath%3E %3C/defs%3E %3C/svg%3E";
export { SvgCircleCheck4 as ReactComponent };